import * as THREE from "three";
import { CAMERA, clamp } from "@mucki/shared";

export interface ThirdPersonCamera {
  update(target: THREE.Vector3Like, yaw: number, pitch: number, delta: number): void;
}

/**
 * Trails the cat at the configured distance and eases toward the desired spot,
 * so the camera lags slightly instead of snapping. Camera collision against
 * scenery is deferred (see the plan's follow-up work).
 */
export function createThirdPersonCamera(camera: THREE.PerspectiveCamera): ThirdPersonCamera {
  const desired = new THREE.Vector3();
  const lookAt = new THREE.Vector3();

  return {
    update: (target, yaw, pitch, delta) => {
      const horizontal = Math.cos(pitch) * CAMERA.distance;
      desired.set(
        target.x + Math.sin(yaw) * horizontal,
        target.y + CAMERA.targetHeight + Math.sin(pitch) * CAMERA.distance,
        target.z + Math.cos(yaw) * horizontal,
      );

      camera.position.lerp(desired, clamp(delta * CAMERA.followRate, 0, 1));
      lookAt.set(target.x, target.y + CAMERA.targetHeight, target.z);
      camera.lookAt(lookAt);
    },
  };
}
